import React, { lazy, Suspense, useEffect, useState } from 'react'
import { Modal } from '@web/walter-ui-kit'
import { useAuth } from '@web/walter-lib/auth'
import { screenSources } from '@walter/shared/constants/posthog'
import Preloader from './Preloader'
import { useCommonCMSConfig, useIsPermalinkSet, useMigrationStatus } from '~api'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'
import { useLatestValue } from '~hooks/useLatestValue'
import { SettingsTabs } from '~modals/SettingsModal/Menu/const'
import { useSettingsModal } from '~modals/SettingsModal/useSettingsModal'

const Content = lazy(() => import('./Content'))

function WalletIdModal() {
    const { isAuth } = useAuth()
    const [isCloseable, setIsCloseable] = useState(false)

    const { isOpen: isMigrationModalOpen } = useModal(ModalTypes.migration)
    const { isOpen, hide, show } = useModal(ModalTypes.walletID)
    const isOpenRef = useLatestValue(isOpen)

    //Todo: Turn on when feature walletId is needed
    const { data: requestData, mutate: mutateIsPermalinkSet } = useIsPermalinkSet({ shouldRequest: false })
    const { data: migrationStatusData, isValidating: isMigrationDataLoading } = useMigrationStatus()

    const isMigration =
        isMigrationDataLoading ||
        isMigrationModalOpen ||
        (migrationStatusData?.fw_migration_start && !migrationStatusData?.fw_migration_finish)

    const { isOpen: isSocialReferralOpen } = useModal(ModalTypes.socialReferral)

    useEffect(() => {
        if (requestData?.data === false && isAuth && !isOpenRef.current && !isMigration && !isSocialReferralOpen) {
            show()
        }
    }, [show, isAuth, isOpenRef, requestData, isMigration, isSocialReferralOpen])

    const onCreate = () => {
        setIsCloseable(true)
        mutateIsPermalinkSet({ data: true }, { revalidate: false })
    }

    const { setTab: setSettingsTab } = useSettingsModal()

    const onVerify = () => {
        hide()
        setSettingsTab(SettingsTabs.identity, { from: screenSources.signUp })
    }

    const referralModal = useModal(ModalTypes.referral)

    const openReferral = () => {
        hide()
        referralModal.show()
    }

    const { showReferral } = useCommonCMSConfig().data?.features ?? {}

    return (
        <Modal
            dataPointer="wallet_id_modal"
            isOpen={isOpen}
            withHeaderBorder={false}
            size="s"
            withCloseButton={isCloseable}
            ignoreEscape={!isCloseable}
            ignoreBackgroundClick={!isCloseable}
            onClose={hide}
        >
            <Suspense fallback={<Preloader />}>
                <Content onVerify={onVerify} onInvite={openReferral} onCreate={onCreate} showReferral={showReferral} />
            </Suspense>
        </Modal>
    )
}

function WalletIdModalWrapper() {
    const { showWalletId: isEnabled } = useCommonCMSConfig().data?.features ?? {}

    if (!isEnabled) {
        return null
    }

    return <WalletIdModal />
}

export default WalletIdModalWrapper
